export interface IAddNotePayload {
  subject: string
  notetext: string
  'objectid_contact@odata.bind'?: string
  'objectid_account@odata.bind'?: string
  mimetype?: string
  filename?: string
  documentbody?: string
  isdocument?: boolean
}
export interface ICreateInteractionPayload {
  aka_type?: number
  subject?: string
  scheduledend?: string
  ram_sentiment?: number
  'regardingobjectid_contact_aka_meetingnote@odata.bind'?: string
  'regardingobjectid_account_aka_meetingnote@odata.bind'?: string
  rcm_meetingpurpose?: string
  rcm_city?: string
  rcm_stateprovince?: string
  rcm_countryregion?: string
  description?: string
  rcm_financialreporting?: number | null
  rcm_reporttype?: string | null
  rcm_reportcoveredfromdate?: string | null
  rcm_reportcoveredtodate?: string | null
  mimeType?: string
  filename?: string
  documentbody?: string
  isdocument?: boolean
  statecode?: number
  statuscode?: number
}

export type TaskSortOrder = 'asc' | 'desc';
export type TaskTimeRange = 'immediate' | 'future' | 'past' | 'all';

export interface ITaskQueryParams {
  profileIds: string[];
  sortOrder: TaskSortOrder;
  searchText?: string;
  timeRange?: TaskTimeRange;
}

export interface ICrmTask {
  activityid: string;
  subject?: string;
  description?: string;
  scheduledend?: string;
  prioritycode?: number;
  statecode?: number;
  statuscode?: number;
  ownerName?: string;
  contactFullName?: string;
  accountName?: string;
  objectId?: string;
  activitytypecode?: string;
  createdon?: string;
  modifiedon?: string;
  filename?: string;
  isExpanded?: boolean;
  showSeeMore?: boolean;
}

export interface ICreateTaskPayload {
  subject: string;
  description?: string;
  scheduledend?: string;
  prioritycode?: number;
  statuscode?: number;
  actualdurationminutes?: number;
  rcm_sendemail?: boolean;
  'ownerid_task@odata.bind'?: string;
  'regardingobjectid_contact_task@odata.bind'?: string;
  'regardingobjectid_account_task@odata.bind'?: string;
}

export const INDIVIDUAL_TASK_STATUS = {
  OPEN: 100000000,
  NOT_STARTED: 2,
  IN_PROGRESS: 3,
  WAITING: 4,
  COMPLETED: 5,
  DEFERRED: 7
} as const;

export type InteractionSortOrder = 'asc' | 'desc';

export interface IInteractionQueryParams {
  profileIds: string[];
  sortOrder: InteractionSortOrder;
  searchText?: string;
  typeFilter?: number | 'all';
}

export interface ICrmInteraction {
  activityid: string;
  subject: string;
  description?: string;
  scheduledend?: string;
  createdon?: string;
  typeLabel?: string;
  typeCode?: number;
  regardingObjectId?: string;
  regardingName?: string;
  city?: string;
  stateProvince?: string;
  countryRegion?: string;
  sentimentCode?: number;
  sentimentLabel?: string;
  meetingPurpose?: string;
  attachmentName?: string;
  serviceTypeCode?: number;
  reportTypeCodes?: string;
  reportCoveredFromDate?: string;
  reportCoveredToDate?: string;
  ownerName?: string;
  modifiedOn?: string;
  isExpanded?: boolean;
  showSeeMore?: boolean;
}

export interface InteractionAttachment {
  value?: string;
}

export type NoteSortOrder = 'asc' | 'desc';

export interface ICrmProfileRef {
  id: string | null | undefined;
  type?: 'contact' | 'account' | 'organization' | string;
}

export interface ICrmNote {
  annotationId: string;
  subject?: string;
  notetext?: string;
  documentbody?: string;
  mimetype?: string;
  filename?: string;
  createdon?: string;
  ownerName?: string;
  contactFullName?: string;
  accountName?: string;
  isExpanded?: boolean;
  showSeeMore?: boolean;
}

export interface INotesQueryParams {
  profileIds: ICrmProfileRef[];
  sortOrder: NoteSortOrder;
  searchText?: string;
  shouldDisplayLast30?: boolean;
}

export interface IAttachmentPayload {
  documentbody?: string;
  mimetype?: string;
  filename?: string;
}

export interface IAttachmentDownloadData {
  filename: string;
  mimetype: string;
  bytes: ArrayBuffer;
}